import {Component} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';
import {Menu} from 'primereact/menu';
import {Paginator} from 'primereact/paginator';
import {LoadingService} from '../../../AppLoading';
import {OrderService as Service} from '../OrderService';
import EventEmitter from '../../../utils/EventEmitter';

export class DialogView extends Component<any, any> {

  private preview;
  private menu;
  private pagehmtl;
  private fullPageHtml;
  constructor(props) {
    super(props);

    this.state = {
      previewHeight: 500,
      basicFirst: 0,
      basicRows: 1,
      totalRecords: 0,
      items: []
    }

    this.onShow = this.onShow.bind(this);
    this.onBasicPageChange = this.onBasicPageChange.bind(this);
  }
  componentDidMount() {    
    const reloadData = () => {
      LoadingService.start();
      this.onShow();
      LoadingService.stop();
    }
    const eventsListner = EventEmitter.addListener("reloadSearchInvoiceSign", reloadData);
    return () => {
      eventsListner.removeListener("reloadSearchInvoiceSign", reloadData)
    }
  }

  onShow() {
    const {selectedItem} = this.props;
    if (this.props.display && selectedItem && selectedItem.id) {

      const items = [];
      let canSign = false;
      if ([0, 3, 4].includes(selectedItem.invoiceStatus) && [2, 4].includes(selectedItem.sendTaxStatus)) {
        items.push({
          label: 'Huỷ hoá đơn',
          command: () => {
            this.props.setDisplayCancel(true);
          }
        });
      }

      if (selectedItem.sendTaxStatus === 1) {
        canSign = true;
      }
      if ([0, 3].includes(selectedItem.invoiceStatus) && [2, 4].includes(selectedItem.sendTaxStatus)) {
        items.push({
          label: 'Thay thế',
          command: () => {
            this.props.setInvoiceStatus(3);
            this.props.setDisplayCrup(true);
          }
        });
      }
      if ([0, 5].includes(selectedItem.invoiceStatus) && [2, 4].includes(selectedItem.sendTaxStatus)) {
        items.push({
          label: 'Điều chỉnh',
          command: () => {
            this.props.setInvoiceStatus(2);
            this.props.setDisplayCrup(true);
          }
        });
      }

      this.setState({
        basicFirst: 0,
        basicRows: 1,
        items,
        canSign
      });
      
      Service.printViewHtml(selectedItem.id).then(data => {
        if (data.pagehmtl) {
          this.pagehmtl = data.pagehmtl;
          let previewHeight;
          if (data.pageSize === 'A5') {
            previewHeight = 610;
          } else {
            previewHeight = 1200;
          }
          this.setState({
            previewHeight,
            totalRecords: data.pagehmtl.length
          });
          this.preview.contentWindow.document.open();
          this.preview.contentWindow.document.write(`${data.pagehmtl[0].trim()}`);

          this.fullPageHtml = '';
          for (const page of data.pagehmtl) {
            this.fullPageHtml += page.trim();
          }
        }
      });
    }
  }

  print() {
    const myWindow = window.open();
    myWindow.document.open('text/plain');
    myWindow.document.write(this.fullPageHtml.trim());
    myWindow.document.close();
    myWindow.onafterprint = myWindow.close;
    myWindow.print();
  }

  printSwitch() {
    const {selectedItem} = this.props;
    if (selectedItem && selectedItem.id) {
      Service.printViewSwitchHtml(selectedItem.id).then(data => {
        if (data.pagehmtl) {

          let html = '';
          data.pagehmtl.forEach(page => {
            html += page.trim();
          });

          const myWindow = window.open();
          myWindow.document.open('text/plain');
          myWindow.document.write(html);
          myWindow.document.close();
          myWindow.onafterprint = myWindow.close;
          myWindow.print();
        }
      });
    }
  }

  signInvoice() {
    const {selectedItem} = this.props;
    if (selectedItem && selectedItem.id) {
      const InvoiceIdArray = [selectedItem['id']];
      this.props.sign({
        "CommandName": "SignInvoices",
        "InvoiceIdArray": InvoiceIdArray
      });
      selectedItem.sendTaxStatus = 2;
    }
  }

  sendEmail() {
    const {selectedItem} = this.props;
    EventEmitter.emit("showDialogSendEmail", selectedItem);
    this.props.setDisplaySendEmail && this.props.setDisplaySendEmail(true);
  }

  downloadPdf() {
    const {selectedItem} = this.props;
    if (selectedItem && selectedItem.id) {
      Service.downloadInvoicePdf(selectedItem.id).then(data => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob([data]));
        link.download = `${selectedItem['buyerTaxCode']}_${selectedItem['invoiceSerial']}_${selectedItem['invoiceNumber']}.pdf`;
        link.click();
      });
    }
  }

  onBasicPageChange(event) {
    this.setState({
      basicFirst: event.first,
      basicRows: event.rows
    });
    this.preview.contentWindow.document.open();
    this.preview.contentWindow.document.write(`${this.pagehmtl[event.first].trim()}`);
  }

  render() {
    const myIcon = (
      <div className="mr-2 grid">
        <div className="col-fixed p-0 pt-2 mr-3" style={{width: '300px'}}>
          <Paginator first={this.state.basicFirst} rows={this.state.basicRows} totalRecords={this.state.totalRecords} onPageChange={this.onBasicPageChange} pageLinkSize={3}></Paginator>
        </div>
        <div className="col-fixed p-0 pt-3 text-right" style={{width: '510px'}}>
          {this.state.canSign === true &&
						<Button label="Ký gửi CQT" icon="pi pi-print" onClick={() => this.signInvoice()} className="p-button-outlined p-button-sm mr-2"/>
          }
          <Button label="Chuyển đổi" icon="pi pi-print" onClick={() => this.printSwitch()} className="p-button-outlined p-button-sm mr-2"/>
          <Button label="In HĐ" icon="pi pi-print" onClick={() => this.print()} className="p-button-outlined p-button-sm mr-2"/>
          <Button label="Tải PDF" icon="pi pi-file-pdf" onClick={() => this.downloadPdf()} className="p-button-outlined p-button-sm mr-2"/>

          {!!(this.props.setDisplayCrup && this.state.items && this.state.items.length) &&
						<>
							<Menu model={this.state.items} popup ref={el => this.menu = el}/>
							<Button label="Xử lý sai sót" icon="pi pi-bars" onClick={event => this.menu.toggle(event)} className="p-button-outlined p-button-sm mr-2"/>
						</>
          }
          <Button label="Gửi email" icon="pi pi-envelope" onClick={() => this.sendEmail()} className="p-button-outlined p-button-sm mr-2"/>
        </div>
      </div>
    );
    return (
      <Dialog icons={myIcon} visible={this.props.display} style={{width: '890px'}} draggable={false} resizable={true} position="top"
              onHide={() => this.props.setDisplay(false)} onShow={this.onShow} className="view-invoice">
        <iframe className="template-preview" ref={(el) => this.preview = el} title="template-preview" style={{height: this.state.previewHeight + 'px'}}/>
      </Dialog>
    );
  }

}